import React from 'react';

const slides = [
  {
    id: 1,
    title: 'Meeting 1 - Introduction',
    embedUrl: 'https://docs.google.com/presentation/d/13CJoPjzu8AhNzn_KUu8Rgx3zeZAFQn1FQM0slwGzhJs/preview',
    directUrl: 'https://docs.google.com/presentation/d/13CJoPjzu8AhNzn_KUu8Rgx3zeZAFQn1FQM0slwGzhJs/'
  },
  {
    id: 2,
    title: 'Meeting 2 - Literature Review',
    embedUrl: 'https://docs.google.com/presentation/d/1VkE7qPT3-OuwyPklIMa7IlTJaAD0rYgW6CWSNFI1Rqo/preview',
    directUrl: 'https://docs.google.com/presentation/d/1VkE7qPT3-OuwyPklIMa7IlTJaAD0rYgW6CWSNFI1Rqo/'
  },
  {
    id: 3,
    title: 'Meeting 3 - Brainstorming',
    embedUrl: 'https://docs.google.com/presentation/d/17QdM9ZuySh-NEVnfo0PpWX07O55N24kzkoNmyuPupqA/preview',
    directUrl: 'https://docs.google.com/presentation/d/17QdM9ZuySh-NEVnfo0PpWX07O55N24kzkoNmyuPupqA/'
  }
];

function ClubPresentationSlides() {
  return (
    <div>
      {/* Hero Section */}
      <div style={{ backgroundColor: "#f8f9fa", padding: "60px 0 50px 0" }}>
        <div className="container">
          <div style={{ maxWidth: "800px" }}>
            <h1 style={{
              fontSize: "clamp(2rem, 4vw, 2.5rem)",
              fontWeight: "700",
              color: "#1a1a2e",
              marginBottom: "16px",
              letterSpacing: "-0.02em"
            }}>
              Research Club Presentation Slides
            </h1>
            <p style={{
              fontSize: "1.1rem",
              color: "#555",
              lineHeight: "1.7"
            }}>
              Sets of presentation slides that you can use in your club meetings. Perfect for introducing research concepts and facilitating discussions.
            </p>
          </div>
        </div>
      </div>

      <div className="container" style={{ padding: "50px 0 80px 0" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: "40px" }}>
          {slides.map((slide) => (
            <div
              key={slide.id}
              style={{
                background: "#fff",
                borderRadius: "16px",
                overflow: "hidden",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.06)",
                border: "1px solid #e8eef3"
              }}
            >
              {/* Header */}
              <div style={{
                padding: "20px 28px",
                borderBottom: "1px solid #e8eef3",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "12px"
              }}>
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  <span style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "32px",
                    height: "32px",
                    borderRadius: "8px",
                    backgroundColor: "rgba(0, 77, 153, 0.08)",
                    color: "#004d99",
                    fontWeight: "700",
                    fontSize: "0.9rem"
                  }}>
                    {slide.id}
                  </span>
                  <h2 style={{
                    fontSize: "1.25rem",
                    fontWeight: "600",
                    color: "#1a1a2e",
                    margin: 0
                  }}>
                    {slide.title}
                  </h2>
                </div>
                <a
                  href={slide.directUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    padding: "8px 16px",
                    borderRadius: "8px",
                    backgroundColor: "#004d99",
                    color: "#fff",
                    textDecoration: "none",
                    fontSize: "0.9rem",
                    fontWeight: "500",
                    transition: "background-color 0.2s ease"
                  }}
                >
                  Open in Google Slides
                </a>
              </div>

              {/* Embedded Presentation */}
              <div style={{ padding: "0" }}>
                <iframe
                  title={slide.title}
                  src={slide.embedUrl}
                  style={{
                    width: "100%",
                    height: "500px",
                    border: "none"
                  }}
                  allow="autoplay"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ClubPresentationSlides;
